export enum DayOfWeekEnum {
  SUN = "Sunday",
  MON = "Monday",
  TUE = "Tuesday",
  WED = "Wednesday",
  THU = "Thursday",
  FRI = "Friday",
  SAT = "Saturday",
  HOL = "PublicHolidays",
}
// 1: Giảm giá sản phẩn , 2: Điều chỉnh giá ( chính sách giá) , 3: Giá Grab(không sử dụng nữa) , 4: Khuyến mãi ko rớt hàng, 5: Khuyến mãi có rớt hàng, 6: Khuyến mãi combo, 7 voucher, 8 acquire user
export enum CategoryPromotionEnum {
  PROMOTION_NORMAL = 1,
  PROMOTION_DISCOUNT = 2,
  PROMOTION_GRABPAY = 3,
  PROMOTION_NO_DROP = 4,
  PROMOTION_DROP_PRODUCT = 5,
  PROMOTION_COMBO = 6,
  PROMOTION_VOUCHER = 7,
  PROMOTION_SAMPLING = 8,
  PROMOTION_PLAY_GAME = 9,
}

// Walet
export enum WalletEnum {
  TORO = 1,
  VOUCHER = 2,
  CASH = 3,
  GRAB = 4,
  MOMO = 6,
  ZALO = 7,
  SHOPEEPAY = 8,
  SMARTPAY = 9,
  CARDATM = 10,
  SAMPLING = 11,
  LOYALTY = 13,
  VNPAY = 14,
  VNPAY_ONLINE = 15,
  SHOPEEPAY_ONLINE = 16,
  MOCA_ONLINE = 17,
  SMARTPAY_ONLINE = 18,
  VNPT_ONLINE = 19,
  MOMO_ONLINE = 20,
  APPOTA_ONLINE = 22,
  VIETTELPAY_OFFLINE = 23,
  VIETTELPAY_ONLINE = 24,
  EDC_TPBANK = 25,
  BEE_CLASS = 26,
  GALAXY = 27,
  CASH_VOUCHER = 28,
  VINAID = 31,
}

// buyType
export enum BuyTypeEnum {
  BUY = 1,
  FREE = 2,
}

// Timeout
export enum TimeoutEnum {
  SECONDS_MESS_15 = 15,
}


// Dòng máy
export enum MachineModelTypeEnum {
  CAFE = 1,
  NORMAL = 0,
  SERVICE = 2,
}


// Kiểu bán hàng
export enum SellingTypeEnum {
  SINGLE = "SINGLE",
  MULTI = "MULTI",
}

// Kiểu bán hàng
export enum SelectProduModeEnum {
  SLOT = "SLOT",
  DETAIL = "DETAIL",
}

// Loại đơn hàng
export enum CreateTypeEnum {
  VOUCHER = "VOUCHER",
}

// Loại đơn hàng
export enum VersionEnum {
  version = "Version: 2026/04/21 13:00:01",
}

export enum RequestVinaIdEnum {
  REQUEST_PAYMENT = "REQUEST_PAYMENT",
  QUERY_PAYMENT_STATUS = "QUERY_PAYMENT_STATUS",
  REQUEST_REFUND = "REQUEST_REFUND",
  QUERY_REFUND_STATUS = "QUERY_REFUND_STATUS",
  PAYMENT_RESULT = "PAYMENT_RESULT",
  REFUND_RESULT = "REFUND_RESULT",
  CANCEL_PAYMENT = "CANCEL_PAYMENT",
  CANCEL_PAYMENT_RESULT = "CANCEL_PAYMENT_RESULT",
}
